<template>
    <div>
        <section class="course-progress-protocol">
            <div class="course-progress-protocol__heading">
                {{ trans('reporting.page_title.instructionshistory')}}
            </div>

            <div class="course-progress-protocol-row" v-for="course_progress in courseProgresses" :key="course_progress.id">
                <div class="course-progress-protocol-row__icon-wrapper">
                    <div v-if="isCompleted(course_progress)" class="course-progress-protocol-row__icon course-progress-protocol-row__icon--finished">
                        <svg width="30" height="30" viewBox="0 0 76 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.876923 31.9C0.292308 31.32 0 30.45 0 29.87C0 29.29 0.292308 28.42 0.876923 27.84L4.96923 23.78C6.13846 22.62 7.89231 22.62 9.06154 23.78L9.35385 24.07L25.4308 41.18C26.0154 41.76 26.8923 41.76 27.4769 41.18L66.6461 0.87H66.9385C68.1077 -0.29 69.8615 -0.29 71.0308 0.87L75.1231 4.93C76.2923 6.09 76.2923 7.83 75.1231 8.99L28.3538 57.13C27.7692 57.71 27.1846 58 26.3077 58C25.4308 58 24.8462 57.71 24.2615 57.13L1.46154 32.77L0.876923 31.9Z" fill="white"/>
                        </svg>
                    </div>

                    <div v-else class="course-progress-protocol-row__icon course-progress-protocol-row__icon--not-finished">
                        <svg width="30" height="30" viewBox="0 0 83 83" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M41.4793 0C18.5505 0 0 18.5713 0 41.5C0 64.4287 18.5505 83 41.4793 83C64.408 83 83 64.4287 83 41.5C83 18.5713 64.408 0 41.4793 0ZM41.5 74.7C23.157 74.7 8.3 59.843 8.3 41.5C8.3 23.157 23.157 8.3 41.5 8.3C59.843 8.3 74.7 23.157 74.7 41.5C74.7 59.843 59.843 74.7 41.5 74.7ZM43.575 20.75H37.35V45.65L59.1168 58.7225L62.25 53.618L43.575 42.5375V20.75Z" fill="white"/>
                        </svg>
                    </div>
                </div>

                <div class="course-progress-protocol-row__information">
                    <div class="label">
                        {{ trans('reporting.label.assigned_date') }}
                    </div>

                    <div class="value">
                        {{ course_progress.assigned_at }}
                    </div>
                </div>

                <div class="course-progress-protocol-row__information">
                    <div class="label">
                        {{ trans('reporting.label.status') }}
                    </div>

                    <div class="value">
                        {{ course_progress.status }}
                    </div>
                </div>

                <div class="course-progress-protocol-row__button">
                    <a
                        v-if="isCompleted(course_progress)"
                        class="btn btn--tertiary btn--big"
                        :href="route('tenant.reporting.certificate', course_progress.id)"
                    >
                        {{ trans('reporting.tooltips.actions.download_certificate') }}
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: [
        'courseProgresses',
    ],

    methods: {
        isCompleted(courseProgress) {
            return courseProgress.status_raw == 'completed';
        }
    },
}
</script>
